export const SUCCESS_MESSAGE = 'You are subscribed to this notification';
export const FAILURE_MESSAGE = 'Something went wrong. Please try again later.';
